<div>
  <div class="image">
    <a (click)="onCompetitionClick()">
      <img [src]="getCompetitionSrc()" alt="" class="quest-img" />
    </a>
  </div>
</div>
